import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Search from './components/Search';

// Theme
import "./themes/bootstrap5_bhic/theme.scss";
import "./themes/bootstrap5_bhic/theme_wcag.scss";

const App = () => (
    <BrowserRouter>
        <Routes>
            <Route path='/' element={<Search/>} />
            <Route path='/web/portal_react' element={<Search/>} />
            <Route path='/web/portal_react/' element={<Search/>} />
            <Route path="*" element={<Search/>} />
        </Routes>
    </BrowserRouter>
);
export default App;